import { find } from './dom';

export interface Toast {
  show(message: string): void;
}

const visibleForMilliseconds = 2600;

// Kratka potvrda je popover (gornji sloj), pa se vidi i preko otvorenog modalnog prozora; svaki novi prikaz ide na vrh.
export function createToast(): Toast {
  const toast = find(document, 'toast', HTMLElement);
  let fade: Animation | undefined;

  return {
    show(message) {
      fade?.cancel();
      if (toast.matches(':popover-open')) toast.hidePopover();
      toast.textContent = message;
      toast.showPopover();
      fade = toast.animate(
        [{ opacity: 0 }, { opacity: 1, offset: 0.08 }, { opacity: 1, offset: 0.85 }, { opacity: 0 }],
        {
          duration: visibleForMilliseconds,
          easing: 'ease-out',
        }
      );
      fade.onfinish = () => toast.hidePopover();
    },
  };
}
